module.exports = __webpack_public_path__ + "img/23.f3f58725.gif";